
export const vuxIsShowPay = state => {
    return state.showPayModal
}

export function VuexRoutes(state) {
    return state.routes
}